export class HeroBannerTournament {
    constructor(selector) {
      this.timerElements = document.querySelectorAll(selector);
      if (this.timerElements) {
        this.init();
      }
    }

    init() {
        this.timerElements.forEach((element) => {
            const dateTimer = element.dataset.timer;
            if (dateTimer) {
                this.startTimer(element);
            }
        });
    }

    startTimer(element) {
        setInterval(() => {
            const now = new Date().getTime();
            const distance = new Date(element.dataset.timer).getTime() - now;
            if (distance < 0) {
                clearInterval(this);
                element.innerHTML = "0d 0h 0m 0s";
                return;
            }

            // Time calculations for days, hours, minutes and seconds
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            if(!days && !hours && !minutes && !seconds) {
                return;
            }

            element.innerHTML = `${days}d ${hours}h ${minutes}m ${seconds}s`;
        }, 1000);
    }
}

new HeroBannerTournament('.timer span.time');
